/**
 * PageHeader - Header fisso per le pagine
 * Non scrolla mai e rimane sempre visibile
 */

import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface PageHeaderProps {
  children: ReactNode;
  paddingTop?: number | string;
  marginBottom?: number | string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ 
  children, 
  paddingTop = 3,
  marginBottom = 4 
}) => {
  return (
    <Box sx={{ 
      flexShrink: 0,
      pt: paddingTop,
      mb: marginBottom
    }}>
      {children}
    </Box>
  );
};

export default PageHeader;
